<template>
<div class="catalog">
	<!-- 无章节目录	-->
	<div class="no-catalog" v-if="trainingInfo.isPhase === 0">
		<div class="catalog-item" v-for="item in trainingInfo.trainContentList" :key="item.id" @click="toToCourse(item)">
			<div class="catalog-pic">
				<van-image v-if="item.coverUrl" :src="item.coverUrl" lazy-load fit="cover" />
				<van-image v-else :src="CourseDefault" lazy-load fit="cover" />
				<div class="type-box">
					<div class="type"></div>
					<span class="type-txt">{{ typeArr[item.type] }}</span>
				</div>
			</div>
			<div class="catalog-info">
				<div class="name van-multi-ellipsis--l2">
					<span class="try-mark" v-if="item.canTryLook">试看</span>
					<span>{{ item.name }}</span>
				</div>
				<div class="time" v-if="item.type === 0">
					包含{{ item.contentNum }}个内容
				</div>
			</div>
		</div>
	</div>
	<!-- 有章节目录	-->
	<div class="have-catalog" v-else-if="trainingInfo.isPhase === 1">
		<div class="have-header" @click="openChoose">
			<span>选择阶段</span>
			<van-icon name="play" size="18px" color="#777777" />
		</div>
		<div class="have-item" v-for="item in trainingInfo.trainPhaseList" :key="item.id" :id="`phase${item.id}`">
			<div class="have-title van-ellipsis">{{ item.name }}</div>
			<div class="no-catalog" v-if="item.contentList && item.contentList.length > 0">
				<div class="catalog-item" v-for="itm in item.contentList" :key="itm.id" @click="toToCourse(itm)">
					<div class="catalog-pic">
						<van-image v-if="itm.coverUrl" :src="itm.coverUrl" lazy-load fit="cover" />
						<van-image v-else :src="CourseDefault" lazy-load fit="cover" />
						<div class="type-box">
							<div class="type"></div>
							<span class="type-txt">{{ typeArr[itm.type] }}</span>
						</div>
					</div>
					<div class="catalog-info">
						<div class="name van-multi-ellipsis--l2">
							<span class="try-mark" v-if="itm.canTryLook">试看</span>
							<span>{{ itm.name }}</span>
						</div>
						<div class="time" v-if="itm.type === 0">
							包含{{ itm.contentNum }}个内容
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<van-action-sheet v-model="chooseShow">
		<div class="choose">
			<div class="choose-title" @click="chooseShow=false">
				<span>选择阶段</span>
				<van-icon name="play" size="18px" color="#777777" />
			</div>
			<div class="choose-list">
				<div class="choose-item" v-for="item in trainingInfo.trainPhaseList" :key="item.id" @click="goToChooseItem(item.id)">
					<span>{{ item.name }}</span>
				</div>
			</div>
		</div>
	</van-action-sheet>
</div>
</template>
<script>
import TestPic from '@/assets/image/learning/test.png'; // 默认图片
export default {
	name: "Catalog",
	data() {
		return {
			// 返回按钮
			CourseDefault: TestPic,
			typeArr: ["课程", "考试"],
			chooseShow: false,
		};
	},
	props: {
		// 课程目录
		trainingInfo: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		openChoose() {
			this.chooseShow = true;
		},
		goToChooseItem(id) {
			this.chooseShow = false;
			// 同时切换到对应的阶段
			this.$nextTick(()=>{
				// 计算phase${ id }距离顶部的高度
				let element = document.getElementById(`phase${ id }`); // 替换为你的元素ID
				let rect = element.getBoundingClientRect();
				let distanceToTop = rect.top + window.scrollY - 100;
				window.scrollTo({
					top: distanceToTop,
					behavior: 'smooth' // 平滑滚动
				});
			})
		},
		// 跳转到课程详情
		toToCourse(item){
			if(item.type === 1){
				// 考试不能试看
				this.$toast('考试不能试看');
			}else{
				// 跳转到课程详情
				this.$router.push({
					path: '/trainingCourse',
					query: {
						trainId: this.trainingInfo.id,
						courseId: item.contentId,
					}
				})
			}
		},
	},
}
</script>
<style scoped lang="css">
*{
	box-sizing: border-box;
}
.catalog{
	width: 100%;
	padding: 0 15px 15px;
}

.no-catalog {
	margin-top: 17px;
}
.no-catalog .catalog-item{
	width: 100%;
	display: flex;
	margin-bottom: 11px;
}
.catalog-pic{
	position: relative;
	width: 109px;
	height: 75px;
	border-radius: 6px;
	margin-right: 10px;
}
.catalog-pic .van-image{
	width: 109px;
	height: 75px;
	border-radius: 6px;
}
.catalog-pic .type-box{
	position: absolute;
	bottom: 4px;
	right: 4px;
}
.catalog-pic .type-box .type{
	width: 33px;
	height: 16px;
	background: #000000;
	border-radius: 8px;
	opacity: 0.4;
	backdrop-filter: blur(7px);
}
.catalog-pic .type-box .type-txt{
	width: 33px;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 10px;
	color: #FFFFFF;
	text-align: center;
	line-height: 16px;
}

.catalog-info{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 2px 0 4px;
}
.catalog-info .name{
	font-size: 14px;
	color: #333333;
	line-height: 23px;
	word-break: break-word;
}
.catalog-info .name .try-mark{
	display: inline-flex;
	justify-content: center;
	width: 33px;
	height: 18px;
	line-height: 18px;
	font-size: 11px;
	color: #F53F3F;
	background: #FFDBDA;
	border-radius: 10px;
	margin-right: 6px;
	transform: translateY(-1px);
}
.catalog-info .time{
	font-size: 11px;
	color: #8C8C8C;
}
.have-catalog .have-header{
	position: sticky;
	top: 45px;
	display: flex;
	align-items: center;
	z-index: 1100;
	background-color: #fff;
	padding: 14px 0;
}
.have-catalog .have-header span{
	font-size: 15px;
	color: #333333;
	margin-right: 3px;
}
.have-catalog .have-header .van-icon{
	transform: rotate(90deg);
}
.have-catalog .have-item{
	margin-bottom: 15px;
}
.have-catalog .have-item .have-title{
	font-weight: 600;
	font-size: 15px;
	color: #333333;
	padding-bottom: 10px;
	border-bottom: 1px solid #F0F0F0;
	margin-bottom: 11px;
}
.choose{
	padding-bottom: 80px;
	max-height: 80vh;
}
.choose .choose-title{
	display: flex;
	align-items: center;
	height: 60px;
	border-bottom: 1px solid #F0F0F0;
	padding-left: 20px;
}
.choose .choose-title span{
	font-weight: 600;
	font-size: 17px;
	color: #555555;
}
.choose .choose-title .van-icon{
	transform: rotate(-90deg);
	margin-left: 4px;
}
.choose-list{
	padding: 0 15px;
}
.choose .choose-item{
	display: flex;
	align-items: center;
	padding: 15px 2px 11px;
	border-bottom: 1px solid #F0F0F0;
}
</style>